import React from "react";
import { Dropdown } from "react-bootstrap";

export const DropdownMenu = ({ children }) => <Dropdown.Menu>{children}</Dropdown.Menu>;
